import { block } from "./styles.js";

export default (name, ownerDocument) => {
    const container = ownerDocument.createElement('div')
    container.classList.add(block)
    container.setAttribute('aria-hidden', "true")
    container.textContent = name.slice(0 ,1)

    return container
}
